<template>
<div>
  <div
    v-show="menuAtivo"
    class="container-telas">
    <div
      v-show="step == 1"
      style="height: 100%; width: 100%;">
      <div class="header-tela">
        <i
          class="fa-solid fa-angle-down me-3"
          :style="{'color': primaryColor}" />
        <span>Data</span>
      </div>
      <div style="padding-top: 30px; padding-left: 30px; padding-right: 30px; height: calc(100% - 50px); width: 100%; overflow: auto;">
        <span style="font-size: 30px; line-height: 20px;">Escolha</span><br>
        <strong
          style="font-size: 30px; line-height: 28px;"
          :style="{'color': primaryColor}">a melhor data</strong>

        <input-data-calendario
          v-if="useCalendar"
          v-model="selectedDate"
          style="margin-top: 20px;"
          :passeio-id="passeioId"
          :is-mobile="true"
          :initial-available-days="initialAvailableDays"
          :calendar-size="calendarSize" />
        <input-data-list
          v-else
          v-model="selectedDate"
          :passeio-id="passeioId"
          style="margin-top: 20px;"
          :available-days="initialAvailableDays"
          :return-days="returnDays"
          :primary-color="primaryColor" />
        <div style="height: 110px; width: 100%; flex-shrink: 0;"></div>
      </div>
    </div>

    <div
      v-show="step == 2"
      style="height: 100%; width: 100%;">
      <div class="header-tela">
        <i
          class="fa-solid fa-angle-down me-3"
          :style="{'color': primaryColor}" />
        <span>{{ nomeItem }}</span>
      </div>
      <div style="padding-top: 30px; padding-left: 30px; padding-right: 30px; height: calc(100% - 50px); width: 100%; overflow: auto;">
        <span style="font-size: 30px; line-height: 20px;">Quantidade</span><br>
        <strong
          style="font-size: 30px; line-height: 28px;"
          :style="{'color': primaryColor}">de {{ nomeItem }}</strong>

        <div
          v-show="loadingAvailability"
          style="text-align: center; margin-top: 20px;">
          <i class="fa-regular fa-hourglass" />
        </div>

        <input-tickets
          v-show="!loadingAvailability && selectedDate"
          v-model="selectedAgeRanges"
          style="margin-top: 20px;"
          :options="ageRanges"
          :selected-date="selectedDate"
          :primary-color="primaryColor"
          :min="quantidadeMinVenda"
          :max="quantidadeMaxVenda"
          :is-mobile="true"
          :moeda="$props.moeda"
          :nome-item="$props.nomeItem"
          @on-complience-state-change="complienceChange" />
        <div style="height: 110px; width: 100%; flex-shrink: 0;"></div>
      </div>
    </div>

    <div
      v-show="step == 3"
      style="height: 100%; width: 100%;">
      <div class="header-tela">
        <i
          class="fa-solid fa-angle-down me-3"
          :style="{'color': primaryColor}" />
        <span>Horário</span>
      </div>
      <div style="padding-top: 30px; padding-left: 30px; padding-right: 30px; height: calc(100% - 50px); width: 100%; overflow: auto;">
        <span
          v-if="horarios.length > 1"
          style="font-size: 30px; line-height: 20px;">Escolha</span><br>
        <strong
          style="font-size: 30px; line-height: 28px;"
          :style="{'color': primaryColor}">{{ tituloAbaHorario }}</strong>

        <input-horario
          v-show="!loadingAvailability && selectedDate"
          v-model="selectedAvailability"
          style="margin-top: 20px;"
          :horarios="horarios"
          :selected-quantities="selectedAgeRanges"
          :primary-color="primaryColor"
          :is-mobile="true"
          :show-remaining-vacancies="showRemainingVacancies"
          :passeio-tipo="passeioTipo"
          :genero-titulo-atividade="generoTituloAtividade"
          :titulo-atividade="tituloAtividade" />
        <div style="height: 110px; width: 100%; flex-shrink: 0;"></div>
      </div>
    </div>

    <div
      v-show="step == 4"
      style="height: 100%; width: 100%;">
      <div class="header-tela">
        <i
          class="fa-solid fa-angle-down me-3"
          :style="{'color': primaryColor}" />
        <span>Opcionais</span>
      </div>
      <div style="padding-top: 30px; padding-left: 30px; padding-right: 30px; height: calc(100% - 50px); width: 100%; overflow: auto;">
        <strong
          style="font-size: 28px; line-height: 28px;"
          :style="{'color': primaryColor}">Melhore sua experiência</strong><br>
        <span style="font-size: 28px; line-height: 26px;">com nossos opcionais</span>

        <input-opcionais
          v-model="selectedOptionals"
          style="margin-top: 20px;"
          :selected-date="selectedDate"
          :max="nPessoas"
          :primary-color="primaryColor"
          :mobile-mode="true"
          :passeio-id="passeioId" 
          :moeda="$props.moeda"
          @optionals-availability-change="av => hasOptionalsAvailable = av" />
        <div style="height: 110px; width: 100%; flex-shrink: 0;"></div>
      </div>
    </div>
  </div>
  
  <div class="footer-container-alert-partial-payment">
    <alerta-pagamento-parcial
      v-if="$props.hasPaymentPartial"
      :preco-parcial-label="$props.precoParcial"
      :porcentagem-parcial="$props.porcentagemParcial"
      :total="(subtotal + totalOpcionais)"
      :moeda="$props.moeda"
      :is-mobile="true" /> 
  </div>
  <div class="footer-container">
    <resumo-compra-mobile
      :current-total="subtotal + totalOpcionais"
      :current-total-desconto="totalDesconto + totalOpcionais"
      :preco="preco"
      :preco-original="precoOriginal"
      :preco-desconto="precoDesconto"
      :display-mode="!menuAtivo"
      :primary-color="primaryColor"
      :can-advance="canAdvance"
      :submitting="isSubmitting"
      :menu-active="menuAtivo"
      :moeda="$props.moeda"
      :preco-label="precoLabel"
      :discount-by-payment-method="$props.discountByPaymentMethod"
      :discount-payment-methods-label="$props.discountPaymentMethodsLabel"
      @iniciar="menuAtivo = true"
      @avancar="avancar"
      @voltar="voltar" />
  </div>
</div>
</template>

<script>
import axios from 'axios';
import api from '@api/store/atividades';

import InputDataCalendario from './components/InputDataCalendario.vue';
import InputDataList from './components/InputDataList.vue';
import InputHorario from './components/InputHorario.vue';
import InputTickets from './components/InputTickets.vue';
import ResumoCompraMobile from './components/ResumoCompraMobile.vue';
import InputOpcionais from './components/InputOpcionais.vue';
import AlertaPagamentoParcial from './components/AlertaPagamentoParcial.vue';

const dateToString = function(date) {
  const mes = date.toLocaleDateString('pt-BR', { month: '2-digit' });
  const dia = date.toLocaleDateString('pt-BR', { day: '2-digit' });
  const ano = date.toLocaleDateString('pt-BR', { year: 'numeric' });
  return ano + '-' + mes + '-' + dia;
};

export default {
  components: { InputDataCalendario, InputDataList, InputHorario, InputTickets, ResumoCompraMobile, InputOpcionais, AlertaPagamentoParcial },
  props: {
    passeioId: {
      type: String,
      default: () => '0',
      required: true
    },
    primaryColor: {
      type: String,
      default: () => '#E88A1D',
      required: true
    },
    preco: {
      type: String,
      default: () => '',
      required: true
    },
    precoOriginal: {
      type: String,
      default: () => '',
      required: true
    },
    precoDesconto: {
      type: String,
      default: () => '',
      required: true
    },
    useCalendar: {
      type: Boolean,
      default: () => true,
      required: true
    },
    initialAvailableDays: {
      type: String,
      default: () => '[]',
      required: false
    },
    returnDays: {
      type: String,
      default: () => '[]',
      required: false
    },
    quantidadeMinVenda: {
      type: String,
      default: () => '0',
      required: false
    },
    quantidadeMaxVenda: {
      type: String,
      default: () => '0',
      required: false
    },
    passeioTipo: {
      type: String,
      default: () => '',
      required: false
    },
    nomeItem: {
      type: String,
      default: () =>'PESSOAS',
      required: false
    },
    moeda: {
      type: String,
      default: () => 'BRL',
      required: true
    },
    showRemainingVacancies: {
      type: Boolean,
      default: () => false,
      required: true
    },
    calendarSize: {
      type: Number,
      default: () => 2,
      required: true
    },
    precoLabel: {
      type: String,
      default: () => '',
      required: true
    },
    tituloAtividade: {
      type: String,
      default: () => 'Atividade',
      required: false
    },
    generoTituloAtividade: {
      type: String,
      default: () => 'f',
      required: false
    },
    precoParcial: {
      type: String,
      default: () => 0,
      required: false
    },
    porcentagemParcial: {
      type: Number,
      default: () => 0,
      required: false
    },
    hasPaymentPartial: {
      type: Boolean,
      default: () => false,
      required: true
    },
    discountPaymentMethodsLabel: {
      type: String,
      default: '',
    },
    discountByPaymentMethod: {
      type: Boolean,
      default: () => false,
      required: true
    },
  },
  data() {
    return {
      selectedDate: null,
      selectedAgeRanges: [],
      selectedOptionals: [],
      selectedAvailability: null,
      horarios: [],
      loadingAvailability: false,
      quantityOK: false,
      isMounted: false,
      isSubmitting: false,
      menuAtivo: false,
      hasOptionalsAvailable: false,
      ageRanges: {},
      step: 1,
    };
  },
  computed: {
    isReady() {
      return this.selectedDate !== null && 
        this.quantityOK &&
        this.selectedAvailability !== null &&
        this.selectedAgeRanges.length > 0;
    },
    tituloAbaHorario() {
      if(this.horarios.length > 1) {
        return 'O melhor horário';
      }

      const titulo = this.tituloAtividade.charAt(0).toUpperCase() + this.tituloAtividade.slice(1).toLowerCase();
      const genero = this.generoTituloAtividade;
      return 'Horário '
        + (genero === 'm' ? 'do seu ' : 'da sua ')
        + titulo;
    },
    nPessoas() {
      let n = 0;
      this.selectedAgeRanges.forEach(ticket => n += ticket.quantidade);
      return n;
    },
    totalSemDesconto() { // Soma sem desconto por período nem Pix ou Espécie
      var r = 0.0;
      this.selectedAgeRanges.forEach(faixa => {
        const precoDe = faixa.preco.precoDe != null 
          ? Number(faixa.preco.precoDe)
          : Number(faixa.preco.preco);
        r += precoDe * faixa.quantidade;
      });
      return r;
    },
    subtotal() { // Soma dos valores considerando desconto por período, mas sem desconto por pagar à vista
      var r = 0.0;
      this.selectedAgeRanges.forEach(faixa => {
        r += Number(faixa.preco.preco) * faixa.quantidade;
      });
      return r;
    },
    descontoPeriodo() { // Total economizado por ter escolhido um período promocional, sem considerar desconto por pagar à vista
      return this.totalSemDesconto - this.subtotal;
    },
    totalDesconto() { // Total já considerando desconto por período e também por pagar à vista
      var r = 0.0;
      this.selectedAgeRanges.forEach(faixa => {
        const preco = faixa.preco.precoDesconto != null 
          ? Number(faixa.preco.precoDesconto)
          : Number(faixa.preco.preco);
        r += preco * faixa.quantidade;
      });
      return r;
    },
    canAdvance() {
      if(this.step == 1 && !this.selectedDate) {
        return false;
      }
      if(this.step == 2 && (this.selectedAgeRanges.length <= 0 || !this.quantityOK)) {
        return false;
      }
      if(this.step == 3 && !this.selectedAvailability) {
        return false;
      }
      return true;
    },
    // Nota: Nenhum dos valores computados acima considera a existencia de opcionais
    totalOpcionais() { // Soma do valor dos opcionais
      var r = 0.0;
      this.selectedOptionals.forEach(op => {
        const preco = Number(op.preco);
        r += preco * op.quantidade;
      });
      return r;
    }
  },
  watch: {
    selectedDate() {
      this.selectedAgeRanges = [];
      this.selectedAvailability = null;
      this.syncPricesAndAvailability();
    },
    menuAtivo() {
      const body = document.getElementsByTagName('body')[0];
      if(this.menuAtivo) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = 'auto';
      }
    }
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    resetState() {
      this.selectedDate = null;
      this.selectedAgeRanges = [];
      this.selectedAvailability = null;
      this.horarios = [];
      this.loadingAvailability = false;
      this.quantityOK = false;
      this.isSubmitting = false;
      this.step = 1;
      this.ageRanges = {};
    },
    avancar() {
      const nEtapas = (this.hasOptionalsAvailable ? 4 : 3);
      if(this.step < nEtapas) {
        this.step++;
      } else {
        this.submit();
      }
    },
    voltar() {
      if(this.step > 1) {
        this.step--;
      } else {
        this.menuAtivo = false;
      }
    },
    complienceChange(ok) {
      this.quantityOK = ok;
    },
    formatMoney(price) {
      let locale = 'pt-Br';

      if (this.$props.moeda === 'USD') {
        locale = 'en-US';
      }
            
      if(price <= 0 || price === null) {
        return Number(0.00).toLocaleString(locale, { style: 'currency', currency: this.$props.moeda });
      }
      return Number(price).toLocaleString(locale, { style: 'currency', currency: this.$props.moeda });
    },
    dataFormatada(data) {
      if(!data) {
        data = new Date();
      }
      const mes = data.toLocaleDateString('pt-BR', { month: '2-digit' });
      const dia = data.toLocaleDateString('pt-BR', { day: '2-digit' });
      const ano = data.toLocaleDateString('pt-BR', { year: 'numeric' });
      return dia + '/' + mes + '/' + ano;
    },
    async syncPricesAndAvailability() {
      this.loadingAvailability = true;
      await this.syncHorarios();
      await this.syncAgeRanges();
      this.loadingAvailability = false;
    },
    async syncHorarios() {
      if(!this.selectedDate) {
        return;
      }
      const data = dateToString(this.selectedDate);
      try {
        const r = await api.listSchedules(this.passeioId, data);
        if(typeof r !== 'object' || Array.isArray(r) || r === null) {
          return;
        }
        const chaves = Object.keys(r);
        const horarios = [];
        chaves.forEach(chave => {
          horarios.push(r[chave]);
        });
        this.horarios = horarios;
      } catch(err) {
        //Empty
      }
    },
    async syncAgeRanges() {
      if(!this.selectedDate) {
        return;
      }
      const data = dateToString(this.selectedDate);
      try {
        const r = await api.listPriceClassifications(this.passeioId, data);
        if(typeof r !== 'object' || Array.isArray(r) || r === null) {
          return;
        }

        this.ageRanges = r;
      } catch(err) {
        //Empty
      }
    },
    async submit() {
      if(!this.isReady || this.isSubmitting) {
        return false;
      }
      this.isSubmitting = true;

      const form = new FormData();
      form.append('type', 'passeio');
      form.append('productId', this.$props.passeioId);
      form.append('time', this.selectedAvailability);
      form.append('date', this.dataFormatada(this.selectedDate));

      this.selectedAgeRanges.forEach(preco => {
        form.append('quantity[' + preco.id + ']', preco.quantidade);
      });
      this.selectedOptionals.forEach(opt => {
        form.append('preSelectedOptionals[' + opt.id + ']', opt.quantidade);
      });

      try {
        const r = await axios.post('/adicionar-ao-carrinho', form);
        if(!r || !r.data || !r.data.redirectUrl) {
          this.emitEventVenda(false, 'O servidor não respondeu corretamente');
          return false;
        }
        window.location.href = r.data.redirectUrl;
      } catch {
        return false;
      }

      return true;
    }
  }
};
</script>

<style scoped>
.footer-container {
    width: 100%;
    height: 80px;
    background-color: white;
    z-index: 200;
    position: fixed;
    bottom: 0px;
    left: 0px;
}



.footer-container-alert-partial-payment {
    width: 100%;
    background-color: white;
    z-index: 200;
    position: fixed;
    bottom: 80px;
    left: 0px;
}

.container-telas {
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 80px;
    background-color: white;
}

.header-tela {
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
    box-shadow: rgb(100 100 111 / 20%) 0px 10px 10px 0px;
}
</style>
